export const getVersionInfo = () => {
  const packageVersion = process.env.REACT_APP_VERSION || 'unknown';
  const gitHash = process.env.REACT_APP_GIT_HASH || 'unknown';
  const environment = process.env.REACT_APP_ENVIRONMENT || 'unknown';

  console.log(`App Version: ${packageVersion}`);
  console.log(`Git Hash: ${gitHash}`);
  console.log(`Environment: ${environment}`);

  if (environment === 'staging') {
    return `${packageVersion}-${gitHash.substring(0, 7)}`;
  }

  return packageVersion;
};

export const getFullVersionInfo = () => {
  return {
    version: process.env.REACT_APP_VERSION || 'unknown',
    gitHash: process.env.REACT_APP_GIT_HASH || 'unknown',
    environment: process.env.REACT_APP_ENVIRONMENT || 'development',
    buildTime: process.env.REACT_APP_BUILD_TIME || 'unknown',
  };
};
